webpackJsonp([170333468178455],{

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	var _Fleet = __webpack_require__(20);
	
	var _Fleet2 = _interopRequireDefault(_Fleet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EconomicEs = function EconomicEs(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page Economic' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Veh\xEDculos Econ\xF3micos para alquilar | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Preguntas frecuentes sobre el alquiler de autos.'
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'es',
	        href: './en/fleet/economic'
	      }]
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Econ\xF3mico'
	    ),
	    _react2.default.createElement(_Fleet2.default, {
	      lang: props.pathContext.langKey,
	      types: props.data.dataJson.fleetTypes,
	      fleet: props.data.dataJson.fleet,
	      features: props.data.dataJson.fleetFeatures,
	      category: 9
	    })
	  );
	};
	
	//Components
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = EconomicEs;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fleet-economic-es-js-76bfa96bb4e66755a835.js